module.exports = __webpack_public_path__ + "media/images/color_admin_v3/profile-cover-06cfb94517d2119ac49fb3d025930a0e.jpg";